export default __webpack_public_path__ + "static/media/BW.3befa1cd.svg";